export const initialState = () => ({
    modules: []
})

export default initialState();